import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import actions from '@/store/actions'
import mutations from '@/store/mutations'
import getters from '@/store/getters'
import splashScreen from '@/store/modules/splash-screen'
import mission from '@/store/modules/mission'
import comment from '@/store/modules/comment'
import candidate from '@/store/modules/candidate'

Vue.use(Vuex)

let plugins = []
if(process.env.NODE_ENV === 'development') {
  plugins.push(createLogger())
}

export default new Vuex.Store({
  plugins,
  state: {
    isLoading: true,
    accuracy: 0,
    AI_Accuracy: 0,
    isAccuracyValid: true,
    accuracyThreshold: 1,
    D: [],
    nextCandidate: 0,
    imageOne: {
      band: 0,
      dataset: 'USNO',
      transformations: {}
    },
    imageTwo: {
      band: 0,
      dataset: 'PanSTARR',
      transformations: {}
    },
    // Filter settings for each image
    filters: {
      konvaImg1: {hasThreshold: false, thresholdValue: 30},
      konvaImg2: {hasThreshold: false, thresholdValue: 70}
    },
    solved: 0,
    skipped: 0,
    inspected: 0
  },
  getters,
  actions,
  mutations,
  modules: {
    splashScreen,
    mission,
    comment,
    candidate
  }
})
